import { c as _c } from "react/compiler-runtime";
import { CampaignStepId, MailingDeliveryStatsApiInterface } from 'modules/campaigns/campaign-steps/types/campaign-step-interface';
import { useEffect, useState } from 'react';
import useUser from 'shared/hooks/use-user';
import { CampaignId } from '../../types/campaign-interface';
import { getChunkedCampaignStepsStatistics } from '../api/campaign-step-api';
interface UseCampaignsStatisticsInterface {
  campaignId: CampaignId;
  campaignStepIds?: CampaignStepId[];
}
const STATISTICS_STEP = 5;
export function useCampaignStepsStatistics(t0) {
  const $ = _c(8);
  const {
    campaignId,
    campaignStepIds
  } = t0;
  const {
    user
  } = useUser();
  const [statistics, setStatistics] = useState();
  let t1;
  if ($[0] !== campaignId || $[1] !== campaignStepIds || $[2] !== user) {
    t1 = () => {
      if (!campaignStepIds || !user) {
        return;
      }
      getChunkedCampaignStepsStatistics(campaignId, campaignStepIds, STATISTICS_STEP, setStatistics);
    };
    $[0] = campaignId;
    $[1] = campaignStepIds;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = campaignStepIds?.length;
  let t3;
  if ($[4] !== t2) {
    t3 = [t2];
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t1, t3);
  let t4;
  if ($[6] !== statistics) {
    t4 = {
      campaignStepsStatisticsData: statistics
    };
    $[6] = statistics;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}